import React from "react";
import { TextInputProps } from "./TextInput.types";

const TextInput: React.FC<TextInputProps> = ({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  disabled = false,
  required = false,
  error,
  theme = "dark", // Default tema dark
}) => {
  const isDark = theme === "dark";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        fontFamily: "Inter, sans-serif",
        gap: "8px",
        width: "100%",
      }}
    >
      {label && (
        <label
          style={{
            fontSize: "14px",
            fontWeight: 500,
            color: isDark ? "#FFFFFF" : "#1a1a1a", // Tema göre label rengi
          }}
        >
          {label}
          {required && <span style={{ color: "red" }}> *</span>}
        </label>
      )}

      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        style={{
          width: "100%",
          height: "40px",
          border: error ? "1px solid red" : `1px solid #424242`,
          borderRadius: "4px",
          backgroundColor: "transparent",
          color: isDark ? "#FFFFFF" : "#1a1a1a",
          padding: "0 12px",
          fontSize: "14px",
          lineHeight: "24px",
          cursor: disabled ? "not-allowed" : "text",
          outline: "none",
          boxSizing: "border-box",
        }}
        onFocus={(e) => {
          if (!error) {
            e.target.style.borderColor = "#5876EE";
          }
        }}
        onBlur={(e) => {
          if (!error) {
            e.target.style.borderColor = "#424242";
          }
        }}
      />

      {error && <span style={{ color: "red", fontSize: "12px" }}>{error}</span>}
    </div>
  );
};

export default TextInput;
